/** Figma `91154:55199` — Web 右侧 Hero 最大宽度 */
export const WELCOME_HERO_PANEL_MAX_WIDTH_PX = 615;

/** Figma `91084:22240` — 左侧表单内容区宽度 */
export const WELCOME_LEFT_CONTENT_MAX_WIDTH_PX = 353;

/** Figma 大屏画板高度（`91154:55199` hero 958 + 上下各 12 inset） */
export const WELCOME_DESKTOP_FRAME_HEIGHT_PX = 982;

/** Figma `91084:22240` / `91107:22838` — 左侧内容区距顶（设计稿绝对值，仅用于推导偏移） */
export const WELCOME_DESKTOP_LEFT_TOP_PX = 274;

/** Figma `91084:22240` / `91107:22838` — 左侧内容区总高度（含 Logo） */
export const WELCOME_DESKTOP_LEFT_BLOCK_HEIGHT_PX = 359;

/**
 * 内容块几何中心相对画板垂直中心的偏移（负 = 略偏上）。
 * 274 + 359/2 − 982/2 = −37.5px @982 高画板。
 */
export const WELCOME_DESKTOP_CONTENT_CENTER_OFFSET_PX =
  WELCOME_DESKTOP_LEFT_TOP_PX +
  WELCOME_DESKTOP_LEFT_BLOCK_HEIGHT_PX / 2 -
  WELCOME_DESKTOP_FRAME_HEIGHT_PX / 2;

/** 随视口高度缩放的垂直偏移，替代固定 padding-top */
export const welcomeDesktopContentVerticalOffsetCss =
  `calc(${WELCOME_DESKTOP_CONTENT_CENTER_OFFSET_PX} / ${WELCOME_DESKTOP_FRAME_HEIGHT_PX} * 100dvh)` as const;

/** Figma Logo 与正文间距 */
export const WELCOME_DESKTOP_LEFT_GAP_PX = 47;

/** Figma `91154:55199` — 右侧 Hero 内边距 */
export const WELCOME_HERO_INSET_PX = 12;

/** 与 Plan Welcome 弹窗壳入场时长对齐，避免动画被遮挡 */

/** H5 全屏背景渐变（Figma `90772:39473`） */
export const WELCOME_H5_BACKGROUND_OVERLAY =
  "linear-gradient(-89.78deg, rgba(44, 45, 10, 0.086) 14.132%, rgba(44, 45, 10, 0.49) 65.188%)";

export const WELCOME_ASSETS = {
  h5Background: "/assets/images/onboard-bg.webp",
  webHero: "/assets/images/onboarding-welcome-hero.png",
  logo: "/assets/images/edgen-logo-v2.svg",
} as const;
